import { batch } from 'react-redux'
import { toast } from 'react-toastify'
import { appendProducts, appendProductsByPriceDescriptions, setLoading, setProduct, setProductCorsError, setProductImageConfig, setProductImageErrorModal, setProductImportingStatus, setProducts, setProductsByPriceDescriptions, setProductsByPriceDescriptionsLoading, setProductsByPriceDescriptionsTotalLength, setProductsTotalLength, setProductsUpdateProduct } from '../../action/product'
import updateProduct from '../../axios/product/put'
import fetchProducts from '../../axios/product'
import { notifyToast, retrieveErrorFromApi } from '../../../helper'
import storeProduct from '../../axios/product/store'
import deleteProduct from '../../axios/product/delete'
import { PER_LOAD } from '../constants'
import { setAppErrors, setSystemFormButtonSave, setNameValidationErrors } from '../../action/system'
import { getForeignSubErrors, parseNameValidationErrors } from '../../../helper/nameValidationErrors'
import importLieferando from '../../axios/product/importLieferando'
import axios from 'axios'
import { resetSystemFormButtonSaveThunk, succeedSystemFormButtonSaveThunk } from '../app'
import getProductImageConfig from '../../axios/product/imageConfig'
import storeImageToCloudinary from '../../axios/photoUpload/post'
import deleteProductImage from '../../axios/product/imageConfig/delete'
import updateProductImageConfig from '../../axios/product/imageConfig/put'
import fetchProduct from '../../axios/product/get'

export const getProductsThunk =
	(page = 0, size = PER_LOAD, title = null, nrTitle = null, productType = null, category = null) =>
		(dispatch) => {
			let categoryId = category
			if (category === 'Without category') categoryId = ''
			if (category === '') categoryId = null
			return fetchProducts({ page, size, title, nrTitle, productType, categoryId })
				.then((res) => {
					if (res && res.data) {
						if (res.headers['x-products-total']) {
							//check size & page make sure we are retrieving all products
							dispatch(setProductsTotalLength(parseInt(res.headers['x-products-total'])))
						}
						if (page > 0 && size > 0) {
							//make sure we're querying pagination
							dispatch(appendProducts(res.data))
							return
						}
						dispatch(setProducts(res.data))
					}
				})
				.catch((error) => {
					dispatch(setAppErrors(retrieveErrorFromApi(error)))
				})
		}

export const deleteProductThunk = (productId) => {
	return (dispatch) => {
		batch(() => {
			dispatch(
				deleteProduct(
					productId,
					() => {
						dispatch(setProductsTotalLength(0))
						dispatch(setProducts([]))
						notifyToast({ message: 'Product successfully removed' })
					},
					(error) => {
						dispatch(setAppErrors(retrieveErrorFromApi(error)))
					},
				),
			)
		})
	}
}

export const updateProductThunk = (productId, data, productImageUploadStep, productImageStatus) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	dispatch(setNameValidationErrors({}))

	return updateProduct(productId, data)
		.then((res) => {
			dispatch(succeedSystemFormButtonSaveThunk())
			if (data.imgConditionsConfirmed && productImageUploadStep === 'NOT_SAVED') {
				dispatch(getProductImageConfigThunk(productId))
			} else if ((productImageStatus === 'REJECTED' || productImageStatus === 'APPROVED') && productImageUploadStep === 'DEFAULT') {
				dispatch(deleteProductImageThunk(productId))
			}
			return dispatch(setProductsUpdateProduct(res.data))
		}).catch(error => {
			dispatch(resetSystemFormButtonSaveThunk())
			const nameErrors = parseNameValidationErrors(error)
			if (nameErrors) {
				dispatch(setNameValidationErrors(nameErrors))
				const foreignSubErrors = getForeignSubErrors(error)
				if (foreignSubErrors.length) dispatch(setAppErrors(foreignSubErrors))
				return
			}
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const storeProductThunk = (data, callbackSuccess) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	dispatch(setNameValidationErrors({}))

	return storeProduct(data)
		.then(res => {
			dispatch(succeedSystemFormButtonSaveThunk())
			if (typeof callbackSuccess === 'function') callbackSuccess()
			if (data.imgConditionsConfirmed) {
				dispatch(getProductImageConfigThunk(res.data.remoteResponse.id))
			}
		})
		.catch(error => {
			dispatch(resetSystemFormButtonSaveThunk())
			const nameErrors = parseNameValidationErrors(error)
			if (nameErrors) {
				dispatch(setNameValidationErrors(nameErrors))
				const foreignSubErrors = getForeignSubErrors(error)
				if (foreignSubErrors.length) dispatch(setAppErrors(foreignSubErrors))
				return
			}
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const importFromLieferandoThunk = (data) => (dispatch) => {
	return importLieferando(data)
		.then((res) => {
			dispatch(setProductImportingStatus(res.data))
		})
		.catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
		.finally(() => dispatch(setLoading(false)))
}

export const getDataFromTakeawayThunk = (data, contryCode) => (dispatch) => {
	axios
		.get(`https://cw-api.takeaway.com/api/v29/restaurant?slug=${data}`, {
			headers: {
				accept: 'application/json, text/plain, */*',
				'accept-language': 'de',
				'x-country-code': contryCode,
			},
		})
		.then((response) => {
			dispatch(importFromLieferandoThunk(response.data))
		})
		.catch((error) => {
			if (!error.status) {
				dispatch(setProductCorsError(true))
				dispatch(setLoading(false))
			} else {
				toast.error('Failed to connect takeaway')
			}
		})
}

export const getProductImageConfigThunk = (productId) => dispatch => {
	return getProductImageConfig(productId)
		.then((res) => {
			dispatch(setProductImageConfig({ ...res.data, productId }))
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const storeImageToCloudinaryThunk = (cloudname, formData, productId) => dispatch => {
	return storeImageToCloudinary(cloudname, formData)
		.then((res) => {
			const imageConfig = res.data
			const data = {
				signature: imageConfig.signature,
				version: imageConfig.version,
				publicId: imageConfig.public_id,
				secureUrl: imageConfig.secure_url,
			}
			dispatch(updateProductImageConfigThunk(productId, data))
		}).catch((error) => {
			if (error.response.status === 420) {
				dispatch(setProductImageErrorModal(true))
			} else {
				dispatch(setAppErrors(retrieveErrorFromApi(error)))
			}
		})
}

export const deleteProductImageThunk = (productId) => dispatch => {
	return deleteProductImage(productId)
		.then(() => {
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateProductImageConfigThunk = (productId, data) => dispatch => {
	return updateProductImageConfig(productId, data)
		.then((res) => {
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const getProductsByPriceTitleIdThunk =
	(page = 0, size = PER_LOAD, productType = null, category = null, priceTitleId = null) =>
		(dispatch) => {
			dispatch(setProductsByPriceDescriptionsLoading(true))
			let categoryId = category
			if (category === 'Without category') categoryId = ''
			if (category === '') categoryId = null
			return fetchProducts({
				page, size,
				productType, categoryId,
				activePosPrices: false,
				enabledForMenu: false,
				priceTitleId,
			}).then((res) => {
				if (res && res.data) {
					dispatch(setProductsByPriceDescriptionsLoading(false))
					if (res.headers['x-products-total']) {
						//check size & page make sure we are retrieving all products
						dispatch(setProductsByPriceDescriptionsTotalLength(parseInt(res.headers['x-products-total'])))
					}
					if (page > 0 && size > 0) {
						//make sure we're querying pagination
						dispatch(appendProductsByPriceDescriptions(res.data))
						return
					}
					dispatch(setProductsByPriceDescriptions(res.data))
				}
			})
				.catch((error) => {
					dispatch(setProductsByPriceDescriptionsLoading(false))
					dispatch(setAppErrors(retrieveErrorFromApi(error)))
				})
		}


export const updateProductDataThunk = (productId, data) => dispatch => {
	return updateProduct(productId, data)
		.then((res) => {
			return dispatch(setProductsUpdateProduct(res.data))
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const storeProductAndOpenThunk = (data) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	dispatch(setNameValidationErrors({}))

	return storeProduct(data)
		.then(res => {
			const productId = res.data.remoteResponse.id
			return fetchProduct(productId)
				.then(productRes => productRes.data)
				.catch(error => {
					dispatch(setAppErrors(retrieveErrorFromApi(error)))
					return { ...data, productId, category: { id: data.categoryId } }
				})
		})
		.then(product => {
			dispatch(setProduct(product))
			if (data.imgConditionsConfirmed) {
				dispatch(getProductImageConfigThunk(product.productId))
			}
			return product
		})
		.catch(error => {
			const nameErrors = parseNameValidationErrors(error)
			if (nameErrors) {
				dispatch(setNameValidationErrors(nameErrors))
				const foreignSubErrors = getForeignSubErrors(error)
				if (foreignSubErrors.length) dispatch(setAppErrors(foreignSubErrors))
				return undefined
			}
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
			return undefined
		})
		.finally(() => {
			dispatch(resetSystemFormButtonSaveThunk())
		})
}

export const updateProductAndStayThunk = (productId, data, productImageUploadStep, productImageStatus) => dispatch => {
	dispatch(setSystemFormButtonSave({ processing: true }))
	dispatch(setNameValidationErrors({}))

	return updateProduct(productId, data)
		.then((res) => {
			if (data.imgConditionsConfirmed && productImageUploadStep === 'NOT_SAVED') {
				dispatch(getProductImageConfigThunk(productId))
			} else if ((productImageStatus === 'REJECTED' || productImageStatus === 'APPROVED') && productImageUploadStep === 'DEFAULT') {
				dispatch(deleteProductImageThunk(productId))
			}
			dispatch(setProductsUpdateProduct(res.data))
			dispatch(setProduct(res.data))
			return res.data
		}).catch(error => {
			const nameErrors = parseNameValidationErrors(error)
			if (nameErrors) {
				dispatch(setNameValidationErrors(nameErrors))
				const foreignSubErrors = getForeignSubErrors(error)
				if (foreignSubErrors.length) dispatch(setAppErrors(foreignSubErrors))
				return undefined
			}
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
			return undefined
		}).finally(() => {
			dispatch(resetSystemFormButtonSaveThunk())
		})
}
